import React from "react";
import Reveal from "./Reveal";
import { LINKS, CHECKOUT_RADIOGRAFIA_49 } from "@/lib/content";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="et-section relative overflow-hidden"
    >
      <div
        aria-hidden
        className="et-orb"
        style={{
          top: "20%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "560px",
          height: "560px",
          background: "#c5a059",
          opacity: 0.16,
        }}
      />

      <div className="et-container relative z-10">
        <Reveal>
          <div className="relative et-glass-strong rounded-3xl px-6 py-12 md:px-16 md:py-16 text-center overflow-hidden">
            <div
              aria-hidden
              className="absolute inset-0 rounded-3xl pointer-events-none"
              style={{
                background:
                  "radial-gradient(ellipse at top, rgba(197,160,89,0.22), transparent 60%)",
              }}
            />

            <div className="relative">
              <div className="et-eyebrow mx-auto">Tu siguiente paso</div>

              <Reveal delay={0.08}>
                <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance max-w-3xl mx-auto">
                  ¿Ordenamos el negocio antes de{" "}
                  <span className="et-text-gold">llenarlo de cacharros?</span>
                </h2>
              </Reveal>

              <Reveal delay={0.16}>
                <p className="mt-5 text-base md:text-lg text-[#f5f2ea]/95 max-w-2xl mx-auto leading-relaxed">
                  Si tienes ventas, clientes y lío interno, la Radiografía te
                  ayuda a decidir qué tocar primero.
                </p>
              </Reveal>

              <Reveal delay={0.24}>
                <a
                  href={CHECKOUT_RADIOGRAFIA_49}
                  target={CHECKOUT_RADIOGRAFIA_49.startsWith("http") ? "_top" : undefined}
                  data-testid="final-cta-button"
                  className="et-btn-primary mt-8 !px-9 !py-4 !text-base"
                >
                  Hacer mi Radiografía por 49 €
                  <ArrowRight className="w-5 h-5" />
                </a>
              </Reveal>

              <Reveal delay={0.32}>
                <p className="mt-5 text-xs uppercase tracking-[0.22em] text-[#f5f2ea]/55">
                  Sin compromiso · Respuesta directa · Sin humo
                </p>
              </Reveal>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
